import React from 'react';

const SessionExpired = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 backdrop-blur-sm flex flex-col justify-center items-center z-[9999] text-white">
      <div className="border-4 border-white/30 border-t-white rounded-full w-10 h-10 animate-spin mb-5"></div>
      <p>Tu sesión ha expirado. Redirigiendo al login...</p>
    </div>
  );
};

export default SessionExpired;
